export default __webpack_public_path__ + "static/media/pokiRadarRover.745a38ba.png";